import { AxiosInstance } from 'axios';
import React from 'react';

export default React.createContext<AxiosInstance | null>(null);
